import React from 'react';
import Text from '../../atoms/text/Text';
import he from 'he';

const stripHtmlTags = (html) => {
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.textContent || div.innerText || '';
};

const deepDecode = (s, maxPasses = 3) => {
  let out = s ?? '';
  for (let i = 0; i < maxPasses; i++) {
    const dec = he.decode(out);
    if (dec === out) break;
    out = dec;
  }
  return out;
};

const sanitize = (html) => {
  return html.replace(/<\s*(script|style)[^>]*>.*?<\s*\/\s*\1\s*>/gis, '');
};

const toInlineBlocksForClamp = (html) => {
  return html
    .replace(/<\s*p(\s+[^>]*)?>/gi, '<span$1>')
    .replace(/<\/\s*p\s*>/gi, '</span><br/>');
};

const HtmlTag = ({
  title,
  variant,
  className,
  maxLines,
  color,
  fill,
  style,
  stripTags,
  externalLineHeight,
  containerStyle,
  originalData,
  inlineForClamp = false,
}) => {
  const divStyles = maxLines
    ? {
        ...style,
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        WebkitLineClamp: maxLines,
        wordBreak: 'break-word',
        lineHeight: externalLineHeight ?? 2,
        ...containerStyle,
      }
    : { wordBreak: 'break-word', lineHeight: externalLineHeight ?? 2 };

  if (stripTags) {
    const plain = stripHtmlTags(deepDecode(title));
    return (
      <Text
        className={className}
        variant={variant}
        textContainerStyle={containerStyle}
        component={
          <div style={divStyles} data-original={originalData}>
            {plain}
          </div>
        }
        color={color}
        fill={fill}
      />
    );
  }

  let html = deepDecode(title);
  if (inlineForClamp && maxLines) html = toInlineBlocksForClamp(html);
  html = sanitize(html);

  return (
    <Text
      className={className}
      variant={variant}
      textContainerStyle={containerStyle}
      component={
        <div
          dangerouslySetInnerHTML={{ __html: html }}
          style={divStyles}
          data-original={originalData}
        />
      }
      color={color}
      fill={fill}
    />
  );
};

export default HtmlTag;
